import { Badge, Button, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { checkValidFormFieldValue } from '../../utils/helper'
import { Tuning2OutlineIcon } from '../../components/AppIcon'

const { Option } = Select

const SignAccountPageAddvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)

  const { filter, setFilter } = props

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(filter?.keyword)) count++
    if (hasValue(filter?.accountKeyword)) count++
    if (hasValue(filter?.type)) count++

    return count
  }, [filter?.keyword, filter?.accountKeyword, filter?.type])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        keyword: filter?.keyword || undefined,
        accountKeyword: filter?.accountKeyword || undefined,
        type: filter?.type || undefined,
      })
    }
  }, [
    filter?.keyword,
    filter?.accountKeyword,
    filter?.type,
    setFieldsValue,
    showFilter,
  ])

  const onFinish = values => {
    setFilter({
      keyword: values?.keyword || null,
      accountKeyword: values?.accountKeyword || null,
      type: values?.type || null,
      page: 1,
    })

    onToggleFilter()
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item label={'Người dùng'} name={'keyword'}>
                <Input allowClear placeholder={'Nhập tên người dùng'} />
              </Form.Item>

              <Form.Item label={'Tài khoản'} name={'accountKeyword'}>
                <Input allowClear placeholder={'Nhập tài khoản'} />
              </Form.Item>

              <Form.Item label={'Chọn loại'} name="type">
                <Select
                  allowClear
                  showSearch
                  placeholder={'Chọn loại'}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  optionFilterProp={'name'}>
                  <Option value={'USER'}>USER</Option>
                  <Option value={'SYSTEM'}>SYSTEM</Option>
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  setFilter({
                    keyword: null,
                    accountKeyword: null,
                    type: null,
                    page: 1,
                  })
                  onToggleFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'authorityStore',
  'connectedCommitteeDocumentStore',
  'loadingAnimationStore'
)(observer(SignAccountPageAddvanceFilterV2))
